<template>
	<v-icon
		v-if="normalizedName"
		class="material-symbols-outlined custom-page-icon"
		:size="size"
		:aria-hidden="label ? null : 'true'"
		:aria-label="label"
		:role="label ? 'img' : null"
	>
		{{ normalizedName }}
	</v-icon>
	<portal-icon v-else name="file-text" :size="size" :label="label"></portal-icon>
</template>

<script>
	import PortalIcon from '@/components/PortalIcon.vue';

	export default {
		name: 'CustomPageIcon',

		components: { PortalIcon },

		props: {
			name: { type: String, required: false, default: '' },
			size: { type: [Number, String], default: 21 },
			label: { type: String, required: false, default: null },
		},

		computed: {
			normalizedName() {
				return this.name ? this.name.trim() : '';
			},
		},
	};
</script>

<style scoped>
	.custom-page-icon {
		color: currentColor !important;
	}
</style>
